export function parseCreatedDate(date: Date | null) {
  return date != null ? new Date(String(date)).toLocaleString() : '-';
}
